import { Button, Card, Grid, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import Body from "../../ui/Body";
import Google_play_left from "./Google_play_left";
import Khiladi_adda from "./Khiladi_adda";
import QwickSilverAvailable from "./Qwick_silver_available";
import { useNavigate } from "react-router-dom";
import auth from "../../config/authaxios";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Upi from "./Upi";
import DailyWithdraw from "./dailywithdraw";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';


export default function Home() {

  const vht = useSelector((state) => state.qwickSilver);
  // console.log('vht',vht.data.response?.daily_slots)
  const [amount, setAmount] = useState(10)
  const [anchorEl, setAnchorEl] = useState(null);
  const [platform, setPlatform] = useState('Gamerpe')
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [coupons, setCoupons] = useState([])
  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorEl1);
  const [Id, setId] = useState();
  const [open2, setOpen2] = React.useState(false);
  const navigate = useNavigate()
  const [process, setProcess] = useState('3')

  const [openDel, setOpenDel] = React.useState(false);

  const handleClickOpen = (_Id) => {
    setId(_Id)
    setOpenDel(true);
  };

  const handleClose = () => {
    setOpenDel(false);
  };

  const handleAmountEl = (event, value) => {
    setAnchorEl(event.currentTarget);
  }

  const handleCloseMenu = (event) => {
    setAnchorEl(null);
    setAmount(event.target.innerText)
  };

  const handlePlatformEl = (event, value) => {
    setAnchorEl1(event.currentTarget);
  }

  const handleCloseMenu1 = (event) => {
    setAnchorEl1(null);
    setPlatform(event.target.innerText)
  };

  useEffect(() => {
    fetchVouchers()
  }, [])

  let fetchVouchers = () => {
    auth.get(`/admin/block-vouchers`)
      .then((res) => {
        const data = res.data?.response
        console.log("data-->", data);
        setCoupons(data)
      }).catch((err) => {
        console.log("err", err)
      })
  }

  const onClickHandler = () => {
    auth.post(`admin/activate/voucher`, { voucherId: Id })
      .then((res) => {
        const data = res
        console.log("data-->", data);
        //  alert(data?.message)
        fetchVouchers()
        setOpenDel(false)
      }).catch((err) => {
        console.log("err", err)
      })
  }


  const [Day, setDay] = useState(null)
  const [Slot, setSlot] = useState(1)
  const [orderBalance, setOrderBalance] = useState(0)

  const selectStyle = {
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #007BFF',
    backgroundColor: '#f8f9fa',
    fontSize: '16px',
    color: '#333',
    cursor: 'pointer',
  };

  const getValue = () => {
    var date = new Date(Day); // Or the date you'd like converted.
    var DateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
    DateTime.setUTCHours(0, 0, 0, 0);
    let isoDateTime = DateTime.toISOString();
    // console.log("isoDateTime",isoDateTime)
    auth.post(`admin/order-amount-by-slot-number`, {
      date: isoDateTime,
      slot_number: Slot
    })
      .then((res) => {
        const data = res.data
        console.log("data-->", data);
        setOrderBalance(data.response?.total_order_amount)

      }).catch((err) => {
        console.log("err", err)
      })
  }
  
  return (
    <>
      <Sidebar />
      <Nabvar />

      <Body>
        <Grid container columnGap={2} rowGap={2}>
          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2 }}>
              <Typography sx={{ my: 2 }} variant="h5" color='primary'>Inactive Coupon</Typography>
              <div style={{ height: "auto", overflow: "auto" }}>
                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                  <thead style={{ background: "#DC8449", color: "#fff", position: "sticky", top: "0px" }}>
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                      <th>Sku</th>
                      {/* { process == '5' && <th>Change Status</th>} */}
                      <th>Image</th>
                      <th style={{ width: "200px" }}>Order Failed Limit</th>
                      <th>Activate</th>

                    </tr>
                  </thead>
                  <tbody style={{ overflowX: "auto" }}>
                    {coupons.length > 0 ? (
                      coupons.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.name}</td>
                          <td>{item?.sku}</td>
                          <td><img src={item?.images?.mobile} width="50px" alt="Coupon" /></td>
                          {/* {processStatus === '5' && <td><Button variant="contained" color="error" onClick={() => { setId(item?._id); setOpen2(true) }}>Return</Button></td>} */}
                          {/* <td>{item?.process_status}</td> */}
                          <td>{item?.order_failed_limit}</td>
                          <td><Button onClick={() => { handleClickOpen(item?._id) }}>Activate</Button></td>
                          {/* <td>{item?.paid_at}</td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>No Data Available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2 }}>
              <Typography sx={{ my: 2 }} variant="h5" color='primary'>Qwick Silver</Typography>
              <QwickSilverAvailable price={amount} />
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2 }}>
              <Stack direction='row' alignItems='center'>
                <Typography sx={{ my: 2, flexGrow: 1 }} variant="h5" color='primary'>Google Play</Typography>
                <Button sx={{ mb: 2 }} variant="contained" onClick={handleAmountEl}>Amount</Button>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleCloseMenu}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left', }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left', }}
                >
                  <MenuItem onClick={handleCloseMenu}>10</MenuItem>
                  <MenuItem onClick={handleCloseMenu}>20</MenuItem>
                  <MenuItem onClick={handleCloseMenu}>30</MenuItem>
                  <MenuItem onClick={handleCloseMenu}>50</MenuItem>
                  <MenuItem onClick={handleCloseMenu}>100</MenuItem>
                </Menu>

                <Button sx={{ mb: 2, ml: 2 }} variant="contained" onClick={handlePlatformEl}>{platform}</Button>
                <Menu
                  anchorEl={anchorEl1}
                  open={open1}
                  onClose={handleCloseMenu1}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left', }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left', }}
                >
                  <MenuItem onClick={handleCloseMenu1}>Gamerpe</MenuItem>
                  <MenuItem onClick={handleCloseMenu1}>Topupx</MenuItem>
                </Menu>
              </Stack>
              <Google_play_left price={amount} platform={platform} />
            </Card>
          </Grid>


          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2 }} >
              <Typography sx={{ my: 2 }} variant="h5" color='primary'>Khiladi Adda</Typography>
              <Khiladi_adda price={amount} />
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2 }} >
              <Typography sx={{ my: 2 }} variant="h5" color='primary'>UPI</Typography>
              <Upi price={amount} />
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2 }} >
              <Typography sx={{ my: 2 }} variant="h5" color='primary'>Check Total Order Balance</Typography>

              <Stack sx={{ my: 2 }} spacing={2} direction="row">
                {vht.data?.response?.daily_slots > 0 && (
                  <div style={{ marginTop: '20px' }}>
                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>
                      Select a slot:
                    </label>
                    <select style={selectStyle} onChange={(e) => setSlot(e.target.value)}>
                      {Array.from({ length: vht.data?.response?.daily_slots }).map((_, index) => (
                        <option key={index} value={index + 1} >
                          {index + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker
                      label="Date"
                      value={Day ? dayjs(Day) : null}
                      onChange={(newValue) => setDay(newValue)}
                    />
                  </DemoContainer>
                </LocalizationProvider>

                {Day && <Button variant="contained" onClick={getValue}>Search</Button>}
              </Stack>
              <Stack spacing={2}>
                <Stack spacing={1} direction='row'>
                  <Typography>Order Balance</Typography>
                  <Typography color='primary'> {orderBalance || 0}</Typography>
                </Stack>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2 }} >
              <Typography sx={{ my: 2 }} variant="h5" color='primary'>Total Daily Withdraw</Typography>
              <DailyWithdraw />
            </Card>
          </Grid>
        </Grid>
      </Body>

      <React.Fragment>
        <Dialog
          open={openDel}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you Sure?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Do you Want to Activate Voucher
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Disagree</Button>
            <Button onClick={onClickHandler} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

    </>
  );
}
